export default "__VITE_PUBLIC_ASSET__529febe0__"